/* Solar Hiker 2026 launch page: mountains, climber, photo stack and photo viewer.
   Loaded from the theme because Shopify's page editor strips <script> from page content.
   Does nothing on pages without #solar-hiker. */
(function () {
  function init() {
    if (!document.getElementById('solar-hiker') || window.__solarHikerInit) return;
    window.__solarHikerInit = true;
    (() => {
      const ROOT = document.getElementById('solar-hiker');
      // restore accessibility labels (Shopify's page editor strips aria-* attributes)
      const setA = (sel, attrs) => ROOT.querySelectorAll(sel).forEach(el => Object.entries(attrs).forEach(([k, v]) => { if (!el.hasAttribute(k)) el.setAttribute(k, v); }));
      setA('#sh-range, #sh-cliff, #sh-climb, .sh-sticker, .sh-strap-row, .sh-map-art, .sh-rose, .sh-map-block, .sh-snap-btn svg, #sh-buy .sh-labels', { 'aria-hidden': 'true' });
      setA('.sh-snap-btn.sh-prev, .sh-z-prev', { 'aria-label': 'Previous photo' });
      setA('.sh-snap-btn.sh-next, .sh-z-next', { 'aria-label': 'Next photo' });
      setA('.sh-z-close', { 'aria-label': 'Close' });
      setA('.sh-gallery', { 'aria-roledescription': 'carousel', 'aria-label': 'Watch photos' });
      setA('.sh-polastack', { 'aria-live': 'polite' });
      setA('.sh-phases', { 'aria-label': 'Evening light phases on the caseback' });
      setA('.sh-mid-cta', { 'aria-label': 'Shop the Solar Hiker' });
      setA('.sh-hero .sh-labels', { 'aria-label': 'Collaborators' });
      setA('#sh-zoom', { 'aria-modal': 'true', 'aria-label': 'Enlarged photo' });
      ROOT.querySelectorAll('section, #sh-shop').forEach(sec => { const h = sec.querySelector('h2[id], h3[id]'); if (h && !sec.hasAttribute('aria-labelledby')) sec.setAttribute('aria-labelledby', h.id); });
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      // full-bleed inside a theme container, minus the scrollbar
      const setSB = () => ROOT.style.setProperty('--sh-sb', (innerWidth - document.documentElement.clientWidth) + 'px');
      setSB(); addEventListener('resize', setSB);
      // smooth in-page jumps without touching the theme's html styles
      ROOT.addEventListener('click', e => {
        const a = e.target.closest('a[href^="#sh-"]'); if (!a) return;
        const t = document.getElementById(a.getAttribute('href').slice(1)); if (!t) return;
        e.preventDefault(); t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
      const cv = document.getElementById('sh-range');
      const ctx = cv.getContext('2d');
      const cliff = document.getElementById('sh-cliff');
      const climb = document.getElementById('sh-climb');
      const climber = document.getElementById('sh-climber');
      const rope = document.getElementById('sh-rope'), rope2 = document.getElementById('sh-rope2');
      const legA = document.getElementById('sh-legA'), legB = document.getElementById('sh-legB');
      const kneeA = document.getElementById('sh-kneeA'), kneeB = document.getElementById('sh-kneeB');
      const bootA = document.getElementById('sh-bootA'), bootB = document.getElementById('sh-bootB');
      const beam = document.getElementById('sh-beam');
      const rest = document.getElementById('sh-rest');
      const tag = document.getElementById('sh-tag'), tagPhase = document.getElementById('sh-tagPhase'), tagPct = document.getElementById('sh-tagPct');

      const R = (i, k) => { const x = Math.sin(i * 127.1 + k * 311.7) * 43758.5453; return x - Math.floor(x); };
      const clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
      const lerp = (a, b, t) => a + (b - a) * t;
      const hex = h => [parseInt(h.slice(1, 3), 16), parseInt(h.slice(3, 5), 16), parseInt(h.slice(5, 7), 16)];
      const mix = (a, b, t) => a.map((v, i) => lerp(v, b[i], t));
      const rgba = (c, a = 1) => `rgba(${c[0] | 0},${c[1] | 0},${c[2] | 0},${a})`;

      let W = 0, H = 0, DPR = 1, HZ = 0, CW = 72, OW = 0;
      const SP = 380; // px of scroll per ridge passed

      // sky stops: progress, top, bottom, light, stars
      const SKY = [
        [0.00, '#bcd8d2', '#f2eedf', 1.00, 0],
        [0.32, '#c6dccd', '#f5ead0', 0.98, 0],
        [0.48, '#f0cf7e', '#f8e3b0', 0.93, 0],
        [0.62, '#de7f4f', '#f2b877', 0.80, 0],
        [0.74, '#6c6598', '#e0977a', 0.62, 0.2],
        [0.86, '#27366a', '#6d6795', 0.46, 0.65],
        [1.00, '#0d1430', '#243058', 0.34, 1],
      ].map(s => [s[0], hex(s[1]), hex(s[2]), s[3], s[4]]);

      function skyAt(p) {
        for (let k = 1; k < SKY.length; k++) {
          if (p <= SKY[k][0]) {
            const a = SKY[k - 1], b = SKY[k], t = (p - a[0]) / (b[0] - a[0]);
            return { top: mix(a[1], b[1], t), bot: mix(a[2], b[2], t), light: lerp(a[3], b[3], t), stars: lerp(a[4], b[4], t) };
          }
        }
        const l = SKY[SKY.length - 1];
        return { top: l[1], bot: l[2], light: l[3], stars: l[4] };
      }
      function phaseName(p) {
        if (p > 0.985) return 'Base camp';
        if (p < 0.38) return 'High sun';
        if (p < 0.56) return 'Golden hour';
        if (p < 0.68) return 'Sunset';
        if (p < 0.80) return 'Civil twilight';
        if (p < 0.92) return 'Nautical twilight';
        return 'Astronomical twilight';
      }

      const GREENS = ['#1f3a2b', '#3a5f3f', '#2f5139', '#86ab98', '#4d6b45', '#244532', '#6f9a82'].map(hex);
      // roughly one ridge in five carries a big snow-capped peak
      const isBig = i => R(i, 40) < 0.2 && R(i - 1, 40) >= 0.2;
      const BIG = ['#24423a', '#3a5470', '#2f4a3c'].map(hex);
      function ridgeBase(i) {
        if (isBig(i)) return { c: BIG[Math.floor(R(i, 42) * 3)], dots: false };
        const r = R(i, 3);
        if (r < 0.10) return { c: hex('#2d4fae'), dots: true };
        if (r < 0.16) return { c: hex('#d9a826'), dots: false };
        if (r < 0.21) return { c: hex('#b9532f'), dots: true };
        return { c: GREENS[((i % 7) + 7) % 7], dots: false };
      }
      function ridgeH(i, u) {
        const a = R(i, 1) * 6.283, b = R(i, 2) * 6.283, c = R(i, 4) * 6.283;
        const f = 0.7 + R(i, 5) * 0.5;
        const v = 0.58 * Math.sin(u * f * 6.283 + a) + 0.28 * Math.sin(u * f * 2.3 * 6.283 + b) + 0.14 * Math.sin(u * f * 4.7 * 6.283 + c);
        return (v + 1) / 2;
      }

      // woven-dot pattern for a few ridges (like the straps)
      const pc = document.createElement('canvas'); pc.width = pc.height = 16;
      const pctx = pc.getContext('2d'); pctx.fillStyle = 'rgba(15,16,12,.9)';
      pctx.beginPath(); pctx.arc(8, 8, 2.6, 0, 6.283); pctx.fill();
      let dotPat = null;

      function progress() {
        const r = ROOT.getBoundingClientRect(), max = r.height - innerHeight;
        return max > 0 ? clamp(-r.top / max) : 0;
      }

      function draw() {
        const p = progress();
        const s = skyAt(p);
        ctx.shadowColor = 'transparent';
        const g = ctx.createLinearGradient(0, 0, 0, HZ + H * 0.08);
        g.addColorStop(0, rgba(s.top)); g.addColorStop(1, rgba(s.bot));
        ctx.fillStyle = g; ctx.fillRect(0, 0, W, H);

        if (s.stars > 0.01) {
          for (let k = 0; k < 110; k++) {
            const x = R(k, 11) * W, y = R(k, 12) * HZ * 0.95;
            const r = R(k, 14) < 0.12 ? 1.8 : 1;
            ctx.fillStyle = `rgba(255,248,225,${s.stars * (0.25 + 0.75 * R(k, 13))})`;
            ctx.fillRect(x, y, r, r);
          }
        }

        // sun sets behind the range
        const sp = clamp(p / 0.66);
        const sunX = W * lerp(0.74, 0.6, sp), sunY = lerp(H * 0.13, HZ + H * 0.1, sp * sp);
        const sunC = mix(hex('#f6cf52'), hex('#ef7a3c'), clamp((p - 0.4) / 0.25));
        const glow = ctx.createRadialGradient(sunX, sunY, 10, sunX, sunY, 140);
        glow.addColorStop(0, rgba(sunC, 0.45)); glow.addColorStop(1, rgba(sunC, 0));
        ctx.fillStyle = glow; ctx.fillRect(sunX - 140, sunY - 140, 280, 280);
        ctx.fillStyle = rgba(sunC); ctx.beginPath(); ctx.arc(sunX, sunY, Math.max(26, W * 0.03), 0, 6.283); ctx.fill();

        // crescent moon rises for twilight (like the caseback)
        if (p > 0.66) {
          const mp = clamp((p - 0.66) / 0.3);
          const mx = W * 0.22, my = lerp(HZ + 20, H * 0.15, mp), mr = 20;
          ctx.fillStyle = 'rgba(244,238,216,.95)';
          ctx.beginPath(); ctx.arc(mx, my, mr, 0, 6.283); ctx.fill();
          const skyC = mix(s.top, s.bot, clamp(my / (HZ + H * 0.08)));
          ctx.fillStyle = rgba(skyC); ctx.beginPath(); ctx.arc(mx + 8, my - 6, mr * 0.92, 0, 6.283); ctx.fill();
        }

        // the range: ridges at integer depths, camera moves forward with scroll
        const cam = reduce ? 0 : Math.max(0, -ROOT.getBoundingClientRect().top) / SP;
        const D = (H - HZ) * 1.3, A = (H - HZ) * 0.5;
        const night = clamp((0.8 - s.light) / 0.45);
        const iMax = Math.floor(cam + 18), iMin = Math.ceil(cam + 0.62);
        const N = W < 700 ? 40 : 72, step = W / N;
        for (let i = iMax; i >= iMin; i--) {
          const rel = i - cam, t = 1 / rel;
          const base = HZ + D * t, amp = A * t;
          const big = isBig(i);
          if (base - amp * (big ? 3.2 : 1) > H + 40) continue;
          const fog = Math.pow(clamp((rel - 0.9) / 16), 0.7) * 0.94;
          const rb = ridgeBase(i);
          let lit = [rb.c[0] * s.light * (1 - 0.18 * night), rb.c[1] * s.light * (1 - 0.08 * night), Math.min(255, rb.c[2] * s.light * (1 + 0.25 * night) + 14 * night)];
          const col = mix(lit, s.bot, fog);

          ctx.beginPath();
          ctx.moveTo(-40, H + 80);
          let px = -step * 2, py = 0;
          const off = R(i, 6) * 10;
          // keep peaks off-center: left or right third of the window, easing outward as they approach
          const side = R(i, 41) < 0.5 ? -1 : 1;
          const frac = 0.2 + R(i, 44) * 0.14;
          const xs = W / 2 + side * W * (0.5 - frac) * (0.85 + 0.25 * Math.min(t, 1));
          const k = (xs - W / 2) / 1200 * rel * 0.9, pw = 0.72;   // peak position and half-width in ridge units
          const yAt = x => {
            const u = (x - W / 2) / 1200 * rel * 0.9;
            let y = base - amp * (0.3 + 0.7 * ridgeH(i, u + off));
            if (big) {
              const d = Math.abs(u - k) / pw;
              if (d < 1) y = Math.min(y, base - amp * (0.3 + 2.9 * Math.pow(1 - d, 1.5)));
            }
            return y;
          };
          py = yAt(px); ctx.lineTo(px, py);
          for (let x = px + step; x <= W + step * 2; x += step) {
            const y = yAt(x);
            ctx.quadraticCurveTo(px, py, (px + x) / 2, (py + y) / 2);
            px = x; py = y;
          }
          ctx.lineTo(px, py); ctx.lineTo(W + 40, H + 80); ctx.closePath();

          if (rel < 9) {
            ctx.shadowColor = `rgba(8,12,8,${0.5 * (1 - fog)})`;
            ctx.shadowBlur = Math.min(60, 10 + 26 * t) * DPR;
            ctx.shadowOffsetY = -Math.min(12, 4 * t) * DPR;
            ctx.shadowOffsetX = 0;
          } else ctx.shadowColor = 'transparent';
          ctx.fillStyle = rgba(col); ctx.fill();

          if (big && fog < 0.97) {
            // snowcap, clipped to the mountain so it follows the slopes
            const cx = W / 2 + k * 1200 / (rel * 0.9);
            const hw = pw * 1200 / (rel * 0.9);
            const top = base - amp * 3.2;
            const line = top + amp * 0.72;
            const glowAmt = clamp(1 - Math.abs(p - 0.6) / 0.12) * 0.45;
            const snow = mix(mix(hex('#f6f3ea'), hex('#f2a37a'), glowAmt).map((v, j) => v * (0.55 + 0.45 * s.light) * (j === 2 ? 1 + 0.12 * night : 1)), s.bot, fog);
            const shade = mix(snow, lit, 0.28);
            ctx.save();
            ctx.shadowColor = 'transparent';
            ctx.clip();
            const jag = n => line + (R(i * 7 + n, 43) - 0.5) * amp * 0.28 + (n % 2 ? amp * 0.14 : 0);
            ctx.beginPath();
            ctx.moveTo(cx - hw, top - 20);
            ctx.lineTo(cx + hw, top - 20);
            for (let n = 0; n <= 8; n++) ctx.lineTo(cx + hw * 0.7 - n * hw * 0.175, jag(n));
            ctx.closePath();
            ctx.fillStyle = rgba(snow); ctx.fill();
            // shaded side of the peak
            ctx.beginPath();
            ctx.moveTo(cx + 1, top - 20);
            ctx.lineTo(cx + hw, top - 20);
            for (let n = 0; n <= 4; n++) ctx.lineTo(cx + hw * 0.7 - n * hw * 0.175, jag(n));
            ctx.lineTo(cx + hw * 0.04, top + amp * 0.3);
            ctx.closePath();
            ctx.fillStyle = rgba(shade); ctx.fill();
            ctx.restore();
          }

          if (rb.dots && fog < 0.75) {
            ctx.shadowColor = 'transparent';
            ctx.globalAlpha = (1 - fog) * 0.42 * s.light;
            ctx.fillStyle = dotPat; ctx.fill();
            ctx.globalAlpha = 1;
          }
        }
        ctx.shadowColor = 'transparent';
        cliff.style.filter = `brightness(${(0.5 + 0.5 * s.light).toFixed(3)})`;
        return { p, s };
      }

      // ---------- cliff ----------
      let prof = [];
      const NS = 'http://www.w3.org/2000/svg';
      function edgeAt(y) {
        const k = clamp((y + 10) / 10, 0, prof.length - 1.001);
        const a = prof[Math.floor(k)], b = prof[Math.floor(k) + 1] || a;
        return lerp(a[0], b[0], k - Math.floor(k));
      }
      function buildCliff() {
        CW = W < 700 ? 40 : 72;
        OW = CW + 110;
        cliff.setAttribute('viewBox', `0 0 ${CW} ${H}`); cliff.style.width = CW + 'px';
        climb.setAttribute('viewBox', `0 0 ${OW} ${H}`); climb.style.width = OW + 'px';
        prof = [];
        for (let y = -10; y <= H + 20; y += 10) {
          const n = 0.5 + 0.28 * Math.sin(y * 0.013 + 1.3) + 0.18 * Math.sin(y * 0.047 + 0.5) + (R(Math.round(y), 21) - 0.5) * 0.3;
          prof.push([CW * (0.1 + 0.34 * clamp(n)), y]);
        }
        let d = `M${CW + 2} -10 `;
        prof.forEach(([x, y]) => d += `L${x.toFixed(1)} ${y} `);
        d += `L${CW + 2} ${H + 20} Z`;
        let edge = 'M' + prof.map(([x, y]) => `${x.toFixed(1)} ${y}`).join(' L');
        let strata = '';
        for (let y = 18; y < H; y += 22 + (R(y, 7) * 14 | 0)) {
          const w = (R(y, 8) - 0.5) * 10;
          strata += `<path d="M0 ${y} Q${CW / 2} ${y + w} ${CW} ${y - w / 2}" stroke="rgba(70,22,10,.35)" stroke-width="${1.2 + R(y, 9) * 2}" fill="none"/>`;
          if (R(y, 10) > 0.6) strata += `<path d="M0 ${y + 5} Q${CW / 2} ${y + 5 + w} ${CW} ${y + 5 - w / 2}" stroke="rgba(255,205,170,.18)" stroke-width="1.2" fill="none"/>`;
        }
        let tufts = '';
        for (let k = 0; k < 7; k++) {
          const y = 80 + R(k, 30) * (H - 220), x = edgeAt(y);
          tufts += `<path d="M${x + 1} ${y} l-3 -7 l3 3 l1 -8 l2 7 l3 -5 l-1 10 Z" fill="#6f9a82"/>`;
        }
        const cl = CW * 0.28, cr = CW * 0.96, ct = H - 64;
        const cave = `<path d="M${cl} ${H + 2} C${cl} ${ct} ${cr} ${ct - 6} ${cr} ${H + 2} Z" fill="#1b100b"/>
          <circle id="sh-lantern-glow" cx="${(cl + cr) / 2}" cy="${H - 20}" r="16" fill="#e2b12a" opacity=".25"/>
          <circle cx="${(cl + cr) / 2}" cy="${H - 20}" r="3.5" fill="#f6cf52"/>`;
        cliff.innerHTML = `<defs>
            <linearGradient id="sh-rock" x1="0" x2="1"><stop offset="0" stop-color="#c8643b"/><stop offset=".55" stop-color="#9a4226"/><stop offset="1" stop-color="#6b2c19"/></linearGradient>
            <clipPath id="sh-rc"><path d="${d}"/></clipPath>
          </defs>
          <path d="${d}" fill="url(#sh-rock)"/>
          <g clip-path="url(#sh-rc)">${strata}</g>
          <path d="${edge}" stroke="#e58a5b" stroke-width="2" fill="none" opacity=".8"/>
          ${tufts}${cave}
          <circle cx="${edgeAt(22) + 7}" cy="22" r="4" fill="#d9d4c4" stroke="#151612" stroke-width="1.5"/>`;
      }

      // ---------- climber ----------
      let phase = 0, lastY = scrollY, lastMove = -1e9, lastT = performance.now(), tagTimer = 0;
      function setLeg(el, knee, boot, hip, fy) {
        const kx = (hip[0] + 56) / 2 + 3, ky = (hip[1] + fy) / 2 - 8;
        el.setAttribute('points', `${hip[0]},${hip[1]} ${kx},${ky} 54,${fy}`);
        knee.setAttribute('cx', kx); knee.setAttribute('cy', ky);
        boot.setAttribute('transform', `translate(55 ${fy})`);
      }
      function placeClimber(p, s, now) {
        const sc = W < 700 ? 0.8 : 1.3;
        const top = 56, bottom = H - 58;
        const y = lerp(top, bottom, p);
        const ex = (OW - CW) + edgeAt(y);
        const moving = now - lastMove < 160;
        if (moving && !reduce) phase += 0.35;
        const sw = reduce ? 0 : Math.sin(phase) * 4;
        setLeg(legA, kneeA, bootA, [30, 27], 22 + sw);
        setLeg(legB, kneeB, bootB, [30, 28], 33 - sw);
        const sway = reduce ? 0 : Math.sin(now / 900) * (moving ? 1 : 2.5);
        climber.setAttribute('transform', `translate(${ex - 58 * sc} ${y - 27 * sc}) scale(${sc}) rotate(${sway.toFixed(2)} 58 27)`);
        rest.setAttribute('transform', `translate(${ex - 60 * sc} ${y - 28 * sc}) scale(${sc}) rotate(${(reduce ? 0 : Math.sin(now / 1600) * 1.2).toFixed(2)} 58 -16)`);
        const hx = resting ? ex - 2 * sc : ex + (31 - 58) * sc;
        const hy = resting ? y - 44 * sc : y;
        const ax = (OW - CW) + edgeAt(22) + 7, ay = 22;
        for (const r of [rope, rope2]) { r.setAttribute('x1', ax); r.setAttribute('y1', ay); r.setAttribute('x2', hx); r.setAttribute('y2', hy); }
        beam.setAttribute('opacity', clamp((0.72 - s.light) / 0.28).toFixed(2));
        // tag
        if (resting) {
          tagPhase.textContent = 'Portaledge break';
          tagPct.textContent = 'zzz';
          tag.classList.add('sh-on');
        } else {
          tagPhase.textContent = phaseName(p);
          tagPct.textContent = Math.round(p * 100) + '% down';
        }
        tag.style.top = (y - 14) + 'px';
        tag.style.right = (OW - (ex - 62 * sc) + 8) + 'px';
        const lg = document.getElementById('sh-lantern-glow');
        if (lg) lg.setAttribute('opacity', (0.2 + 0.6 * clamp((p - 0.9) / 0.1)).toFixed(2));
      }

      let dirty = true, state = null;
      function resize() {
        DPR = Math.min(devicePixelRatio || 1, 1.5);
        W = innerWidth; H = innerHeight;
        HZ = H * (W < 700 ? 0.44 : 0.47);
        cv.width = Math.round(W * DPR); cv.height = Math.round(H * DPR);
        ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
        dotPat = ctx.createPattern(pc, 'repeat');
        buildCliff();
        dirty = true;
      }
      function showTag() {
        tag.classList.add('sh-on');
        clearTimeout(tagTimer);
        tagTimer = setTimeout(() => tag.classList.remove('sh-on'), 1400);
      }
      // easter egg: after 5s with no activity he hangs a portaledge and naps
      const IDLE_MS = 5000;
      let lastAct = performance.now(), resting = false;
      function activity() {
        lastAct = performance.now();
        if (resting) { resting = false; climb.classList.remove('sh-resting'); showTag(); }
      }
      ['scroll', 'wheel', 'pointermove', 'pointerdown', 'keydown', 'touchstart'].forEach(e => addEventListener(e, activity, { passive: true }));
      setInterval(() => {
        if (!resting && performance.now() - lastAct >= IDLE_MS) { resting = true; climb.classList.add('sh-resting'); }
      }, 1000);
      addEventListener('resize', resize);
      addEventListener('scroll', () => {
        if (Math.abs(scrollY - lastY) > 0.5) lastMove = performance.now();
        lastY = scrollY; dirty = true; showTag();
      }, { passive: true });

      function frame(now) {
        if (dirty || !state) { state = draw(); dirty = false; }
        placeClimber(state.p, state.s, now);
        requestAnimationFrame(frame);
      }
      resize();
      requestAnimationFrame(frame);
      setTimeout(showTag, 600);
      document.fonts && document.fonts.ready.then(() => { dirty = true; });
    })();


    // ---------- lightbox ----------
    (() => {
      const box = document.getElementById('sh-zoom'), big = document.getElementById('sh-zoomImg'), count = document.getElementById('sh-zoomCount');
      const imgs = [...document.querySelectorAll('#solar-hiker .sh-main figure img')];
      let i = 0, lastFocus = null, hideT = 0;
      imgs.forEach(im => {
        im.dataset.zoom = '';
        if (im.closest('.sh-pola')) return;
        im.tabIndex = 0; im.setAttribute('role', 'button');
        im.setAttribute('aria-label', 'Enlarge photo: ' + im.alt);
      });
      function show(n) {
        i = (n + imgs.length) % imgs.length;
        big.src = imgs[i].currentSrc || imgs[i].src; big.alt = imgs[i].alt;
        count.textContent = (i + 1) + ' of ' + imgs.length;
      }
      window.openZoom = im => {
        const n = imgs.indexOf(im); if (n < 0) return;
        lastFocus = document.activeElement; clearTimeout(hideT);
        show(n); box.hidden = false; document.documentElement.style.overflow = 'hidden';
        requestAnimationFrame(() => box.classList.add('sh-on'));
        box.querySelector('.sh-z-close').focus();
      };
      function close() {
        box.classList.remove('sh-on'); document.documentElement.style.overflow = '';
        hideT = setTimeout(() => { box.hidden = true; }, 220);
        lastFocus && lastFocus.focus && lastFocus.focus({ preventScroll: true });
      }
      document.querySelector('#solar-hiker .sh-main').addEventListener('click', e => {
        const im = e.target.closest('figure img'); if (im && !im.closest('.sh-pola')) window.openZoom(im);
      });
      document.querySelector('#solar-hiker .sh-main').addEventListener('keydown', e => {
        if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('figure img[data-zoom]')) { e.preventDefault(); window.openZoom(e.target); }
      });
      box.querySelector('.sh-z-close').addEventListener('click', close);
      box.querySelector('.sh-z-prev').addEventListener('click', () => show(i - 1));
      box.querySelector('.sh-z-next').addEventListener('click', () => show(i + 1));
      box.addEventListener('click', e => { if (e.target === box || e.target.classList.contains('sh-z-stage')) close(); });
      addEventListener('keydown', e => {
        if (box.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowRight') show(i + 1);
        else if (e.key === 'ArrowLeft') show(i - 1);
        else if (e.key === 'Tab') {
          const f = [...box.querySelectorAll('button')], a = f.indexOf(document.activeElement);
          e.preventDefault(); f[(a + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
        }
      });
      let sx = null;
      box.addEventListener('pointerdown', e => { sx = e.clientX; });
      box.addEventListener('pointerup', e => { if (sx === null) return; const d = e.clientX - sx; sx = null; if (d < -50) show(i + 1); else if (d > 50) show(i - 1); });
    })();

    // ---------- polaroid stack ----------
    (() => {
      const stack = document.querySelector('.sh-polastack');
      if (!stack) return;
      const cards = [...stack.querySelectorAll('.sh-pola')];
      const now = document.getElementById('sh-snapNow');
      const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
      const rots = [-3, 4, -6, 2.5, -2, 5, -4.5, 3];
      const offs = [[-8, 6], [9, 10], [-5, 15]];
      let order = cards.map((_, i) => i), busy = false;
      function layout() {
        order.forEach((ci, p) => {
          const c = cards[ci], o = p === 0 ? [0, 0] : offs[Math.min(p, 3) - 1];
          c.style.zIndex = cards.length - p;
          c.style.setProperty('--x', o[0] + 'px');
          c.style.setProperty('--y', o[1] + 'px');
          c.style.setProperty('--r', (p === 0 ? rots[ci] * 0.35 : rots[ci]) + 'deg');
          c.style.visibility = p > 3 ? 'hidden' : '';
          c.classList.toggle('sh-top', p === 0);
          c.setAttribute('aria-hidden', p !== 0);
        });
        now.textContent = order[0] + 1;
      }
      function next() {
        if (busy) return;
        const c = cards[order[0]];
        if (reduce) { order.push(order.shift()); return layout(); }
        busy = true;
        c.style.setProperty('--x', '118%'); c.style.setProperty('--y', '-8%'); c.style.setProperty('--r', '16deg');
        setTimeout(() => {
          order.push(order.shift());
          c.style.transition = 'none'; layout(); c.offsetWidth; c.style.transition = '';
          busy = false;
        }, 300);
      }
      function prev() {
        if (busy) return;
        order.unshift(order.pop());
        const c = cards[order[0]];
        if (reduce) return layout();
        busy = true;
        c.style.transition = 'none'; c.style.visibility = ''; c.style.zIndex = cards.length + 1;
        c.style.setProperty('--x', '-118%'); c.style.setProperty('--y', '-8%'); c.style.setProperty('--r', '-16deg');
        c.offsetWidth; c.style.transition = '';
        layout();
        setTimeout(() => { busy = false; }, 300);
      }
      document.querySelector('.sh-gallery .sh-snap-btn.sh-next').addEventListener('click', next);
      document.querySelector('.sh-gallery .sh-snap-btn.sh-prev').addEventListener('click', prev);
      stack.addEventListener('keydown', e => {
        if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); }
        if ((e.key === 'Enter' || e.key === ' ') && window.openZoom) { e.preventDefault(); window.openZoom(cards[order[0]].querySelector('img')); }
      });
      let sx = null;
      stack.addEventListener('pointerdown', e => { sx = e.clientX; });
      addEventListener('pointerup', e => {
        if (sx === null) return;
        const dx = e.clientX - sx; sx = null;
        if (dx < -40) next(); else if (dx > 40) prev(); else if (Math.abs(dx) < 6 && e.target.closest('.sh-polastack') && window.openZoom) window.openZoom(cards[order[0]].querySelector('img'));
      });
      layout();
    })();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
